module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "indicator"
  }, [(_vm.result === '') ? _c('div', {
    ref: "holder"
  }, [_vm._v(" ")]) : _vm._e(), _vm._v(" "), (_vm.result === 'failed') ? _c('div', {
    staticClass: "indicator error"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-remove-sign"
  })]) : _vm._e(), _vm._v(" "), (_vm.result === 'warning') ? _c('div', {
    staticClass: "indicator warning"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-exclamation-sign"
  })]) : _vm._e(), _vm._v(" "), (_vm.result === 'passed') ? _c('div', {
    staticClass: "indicator passed"
  }, [_c('span', {
    staticClass: "glyphicon glyphicon-ok-sign"
  })]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-8e6d38c0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CheckerStatus.vue
// module id = 292
// module chunks = 2